/**
 * Moved to `@sizzlenz/shared-frontend/hooks`.
 * Re-exported here so existing `@/lib/hooks/useDebouncedValue` imports keep working.
 */
export { useDebouncedValue } from '@sizzlenz/shared-frontend/hooks';
